import CreateTermContainer from "./CreatePaymentTermContainer";
export default CreateTermContainer;
